// jwt: https://www.npmjs.com/package/@auth0/angular-jwt
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from './security.service';


@Injectable({
    providedIn: 'root'
})
export class SecurityGuard implements CanActivate {

    constructor(private router: Router, private securityService: SecurityService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if(!this.securityService.token){
            this.router.navigate(['passport','login']);
            return false;
        }
        return true;
    }
}